import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";


export  const hierarchyViewService = {
    getHierarchy : async() => {
        try{
                const response = await axiosInstance.get(API.employee.getUserHierarchy)
        return response.data;
        } catch(error){
            throw error;
        }
     
    },

    getDirectReports: async( supervisorId) => {
        try{
             const response = await axiosInstance.get(API.employee.getHierDirectReports(supervisorId));
             return response.data;
        } catch(error){
            throw error;
        }
    }
};